// extracted by mini-css-extract-plugin
export default {"header":"Namemenu_header__NE7uB","name":"Namemenu_name__TMc0i","webdev":"Namemenu_webdev__DKlmp"};